module.exports = InternalShared('InternalShared/Events/UpdateStyleSettingsPanel');